export const menuPalette = {
  primaryText: "#393939",
  bgTextActive: "#cfe5e5",
  groupSubMenu: "#8d9090",
  textMenuActive: "#000000",
  titleText: "#313183",
  activeRootMenu: "#c9d1d1",
};
